export function requestId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export function shortChatTitle(value) {
  const title = (value || 'New chat').replace(/\s+/g, ' ').trim()
  const characters = Array.from(title)
  if (characters.length <= 48) return title
  let preview = characters.slice(0, 47).join('')
  const space = preview.lastIndexOf(' ')
  if (space > 24) preview = preview.slice(0, space)
  return `${preview.trim()}…`
}

export function newChat(id = requestId()) {
  return {
    id,
    title: 'New chat',
    saved: false,
    isPinned: false,
    preferencesBusy: false,
    preferencesError: '',
    messages: [],
    draft: '',
    pending: null,
    sending: false,
    loading: false,
    error: '',
    nextBefore: null,
    loaded: false,
    retrying: null,
    retryRequests: {}
  }
}

export function mergeMessages(previous, incoming) {
  const operations = new Map(incoming.map(row => [row.operation.id, row.operation]))
  const rows = new Map(previous.map(row => [
    row.id, {
      ...row, operation: operations.get(row.operation.id) || row.operation
    }
  ]))
  incoming.forEach(row => rows.set(row.id, row))
  return [...rows.values()].sort((a, b) => a.id - b.id)
}

export function messageStatus(operation) {
  if (operation.reason === 'configuration_error') return 'AI is not configured yet. Contact Support.'
  if (operation.reason === 'waiting_for_session') return 'Waiting for the previous request'
  const labels = {
    pending: 'Queued',
    running: 'AI is working',
    retry_wait: 'Retry scheduled',
    failed: 'Unable to get an answer',
    blocked: 'Waiting',
    succeeded: 'Answered'
  }
  const label = labels[operation.status] || 'Waiting'
  if (operation.status === 'retry_wait' && operation.next_attempt_at) {
    return `${label} · ${new Date(operation.next_attempt_at).toLocaleTimeString()}`
  }
  return operation.status === 'running' ? `${label} · attempt ${operation.attempt_count}` : label
}
